<script module lang="ts">
  import type { PersonBadgeData } from './values.types';

  export interface Props {
    person: PersonBadgeData | null | undefined;
    /** The nickname in italics below the name, if there is one. */
    withNickname?: boolean;
  }
</script>

<script lang="ts">
  import { CommonTexts } from '../../services/CommonTexts';
  const { person, withNickname = false }: Props = $props();

  const HasName = $derived(Boolean(person?.given_name || person?.family_name));
  const IsNicknameName = $derived(!HasName && Boolean(person?.nickname));
</script>

{#if person && (HasName || IsNicknameName)}
  <span class="personBadge">
    <span class="nameLine">
      {#if person.titles}<small class="titles">{person.titles}</small>{/if}
      {#if IsNicknameName}<em class="anyName">{person.nickname}</em>{/if}
      {#if person.given_name}<span class="givenName">{person.given_name}</span>{/if}
      {#if person.family_name}<strong class="familyName">{person.family_name}</strong>{/if}
    </span>
    {#if withNickname && !IsNicknameName && person.nickname && person.nickname !== person.given_name}
      <span class="nickname">{person.nickname}</span>
    {/if}
  </span>
{:else}
  <span>{CommonTexts.Empty}</span>
{/if}

<style lang="scss">
  @use '../../../styles/mixins';

  .personBadge {
    display: inline-flex;
    flex-direction: column;
    white-space: normal;
    overflow-wrap: break-word;

    .nameLine {
      display: inline-flex;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 0.2em;
    }

    @include mixins.greaterMedium {
      white-space: nowrap;

      .nameLine {
        flex-wrap: nowrap;
        gap: 0.3em;
      }
    }

    .anyName,
    .nickname {
      font-style: italic;
    }

    .nickname {
      font-size: 0.8em;
      display: block;
    }

    .titles {
      font-size: 0.85em;
      font-weight: normal;
      font-style: italic;
    }

    .givenName {
      font-weight: normal;
    }

    .familyName {
      font-weight: bold;
    }
  }
</style>
